import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditProjectExternalLinkRequestFailure() {
      return getState().isFailure;
    },
    isEditProjectExternalLinkRequestPending() {
      return getState().isPending;
    },
    isEditProjectExternalLinkRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
